import { render, staticRenderFns } from "./Listv2.vue?vue&type=template&id=57737ac0"
import script from "./Listv2.vue?vue&type=script&lang=js"
export * from "./Listv2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports